






























import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";

//Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { SetReportSubscriptionsCommand } from "@/model/communication/reportSubscription/SetReportSubscriptionsCommand";
import { ReportSubscription } from "@/model/data/reportSubscription/ReportSubscription";
import { ReportSubscriptionTypeEnum } from "@/model/data/reportSubscription/ReportSubscriptionTypeEnum";
import { ReportSubscriptionChannelEnum } from "@/model/data/reportSubscription/ReportSubscriptionChannelEnum";
import { GetReportSubscriptionCommand } from "@/model/communication/reportSubscription/GetReportSubscriptionCommand";
import { GetReportSubscriptionResData } from "@/model/communication/reportSubscription/GetReportSubscriptionResData";

export default Vue.extend({
    data() {
        return {
            loading: false,
            nextOccurence: null,
            moment,
        };
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
    },
    methods: {
        async getReportSubscriptions() {
            this.loading = true;
            let response = await new GetReportSubscriptionCommand().execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                response.reportSubscriptions.forEach((rs) => {
                    if (rs.reportSubscriptionType == ReportSubscriptionTypeEnum.PlatformMaintenanceReport) {
                        let today = new Date();
                        let oneMonth = new Date(today.setMonth(today.getMonth() + 1));
                        let hour = parseInt(rs.time.split(":")[0]);
                        let minute = parseInt(rs.time.split(":")[1]);
                        this.nextOccurence = Date.UTC(oneMonth.getFullYear(), oneMonth.getMonth(), 1, hour, minute);
                    }
                });
            }
            this.loading = false;
        },
        subscribe() {
            let reportSubscription = new ReportSubscription();
            reportSubscription.reportSubscriptionType = ReportSubscriptionTypeEnum.PlatformMaintenanceReport;
            reportSubscription.days = 1;
            reportSubscription.time = moment.utc().format("HH:mm");
            reportSubscription.channel = ReportSubscriptionChannelEnum.Email;
            this.sendRequest([reportSubscription]);
        },
        unsubscribe() {
            this.sendRequest([]);
        },
        async sendRequest(reportSubscriptions) {
            try {
                this.loading = true;

                let response: GetReportSubscriptionResData = await new SetReportSubscriptionsCommand(reportSubscriptions, true).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.reportSubscriptions.filter((r) => r.reportSubscriptionType == ReportSubscriptionTypeEnum.PlatformMaintenanceReport).length == 0) {
                        this.nextOccurence = null;
                    } else {
                        response.reportSubscriptions.forEach((rs) => {
                            if (rs.reportSubscriptionType == ReportSubscriptionTypeEnum.PlatformMaintenanceReport) {
                                let today = new Date();
                                let oneMonth = new Date(today.setMonth(today.getMonth() + 1));
                                let hour = parseInt(rs.time.split(":")[0]);
                                let minute = parseInt(rs.time.split(":")[1]);
                                this.nextOccurence = Date.UTC(oneMonth.getFullYear(), oneMonth.getMonth(), 1, hour, minute);
                            }
                        });
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending SetReportSubscriptions request ", e);
            }
            this.loading = false;
        },
    },
    mounted() {
        this.getReportSubscriptions();
    },
});
